import {FormikErrors} from 'formik';
import {set} from 'lodash';
import {builderFieldsType} from '../CreateBuilder/builderFields';

export const AD_HOC_FEE_REASON_REQUIRED = 'A fee justification is required';

export const adHocFeeValidator = (
  values: builderFieldsType,
  errors: FormikErrors<builderFieldsType>
): FormikErrors<builderFieldsType> => {
  if (values.adHocFee?.feeType === 'GBP') {
    if (values.adHocFee.monetaryFee && values.adHocFee.planValue) {
      if (Number(values.adHocFee.monetaryFee) > Number(values.adHocFee.planValue)) {
        set(errors, `adHocFee.monetaryFee`, 'Must be less than the plan value');
      }
    }
  } else {
    if (values.adHocFee?.percentFee && values.adHocFee.planValue) {
      if (Number(values.adHocFee?.percentFee) > 100) {
        set(errors, `adHocFee.percentFee`, 'Must be lower than or equal to 100%');
      }
    }
    if (values.adHocFee?.planValue && Number(values.adHocFee?.planValue) === 0) {
      set(errors, `adHocFee.percentFee`, 'Cannot charge a fee on a plan with £0 value');
    }
  }

  if (!values.adHocFee?.reason?.trim()) {
    set(errors, `adHocFee.reason`, AD_HOC_FEE_REASON_REQUIRED);
  }
  return errors;
};
